import { createSlice } from "@reduxjs/toolkit";

const defaultPlanogramTabState = {
  
}

export const planogramTabSlice = createSlice({
  name: "planogramTabs",
  initialState: {
    ...defaultPlanogramTabState
  },
  reducers: {

  }
})